import '@/@fake-db/db'
import { i18n } from '@/plugins/i18n'
import '@/plugins/vue-composition-api'
import '@/styles/styles.scss'
import Vue from 'vue'
import XWUI from '@prettyy/ui'
import VXETable from 'vxe-table'
import SearchForm from '@core/components/search-form/SearchForm.vue'
import XwTable from '@/@core/components/xw-table/XwTable.vue'
import XwPopoVer from '@core/components/xw-popover/XwPopoVer.vue'
import NewPagination from '@core/components/Pagination/index.vue'
import XwStatus from '@core/components/xw-status/XwStatus.vue'
import AppView from '@/views/components/view.vue'
import App from './App.vue'
import './plugins/acl'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import '@core/components-styles/ckEditorCustom.css'
import '@core/components-styles/vueSelectCustom.css'
import 'vxe-table/lib/style.css'
import '@prettyy/ui/dist/css/index.css'
import './styles/element.scss'

const BrowserLogger = require('alife-logger')

// eslint-disable-next-line no-underscore-dangle
const __bl = BrowserLogger.singleton(
  {
    pid: 'djjkfeapl4@c6e3096f38b0927',
    appType: 'web',
    imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
    sendResource: true,
    enableLinkTrace: true,
    behavior: true,
  },

)

VXETable.config({
  width: 150,
  loadingText: '加载中...',
  table: {
    tooltipConfig: {
      enterable: true,
    },
  },
})

Vue.config.productionTip = false
Vue.component('SearchForm', SearchForm)
Vue.component('XwTable', XwTable)
Vue.component('NewPagination', NewPagination)
Vue.component('XwPopoVer', XwPopoVer)
Vue.component('XwStatus', XwStatus)
Vue.component('AppView', AppView)

Vue.use(XWUI)

Vue.use(VXETable)

// 滚动加载更多
Vue.directive('loadmore', {
  bind(el, binding) {
    const bodyWrapper = el.querySelector('.vxe-table--body-wrapper')
    bodyWrapper.addEventListener('scroll', function () {
      if (this.scrollHeight - this.scrollTop <= this.clientHeight + 20) {
        binding.value()
      }
    })
  },
})

Vue.directive('number-only', {
  bind(el, binding, vnode) {
    let pre = vnode.context.value
    el.addEventListener('input', e => {
      const { value } = e.target

      const precision = binding.value || 2

      const regexString = `^(?:\\d+(\\.\\d{0,${precision}})?|\\.\\d{0,${precision}})?$`
      const regex = new RegExp(regexString, 'g')

      if (!regex.test(value)) {
        // 如果输入不符合规则，则恢复为原始值
        e.target.value = pre

        return
      }

      e.target.value = value
      pre = value
    }, true)
  },
})

Vue.directive('trim', {
  inserted(el) {
    el.addEventListener('input', e => {
      e.target.value = e.target.value.trim()
    })
  },
})

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App),
}).$mount('#app')
